import { render } from "./j-icon.vue?vue&type=template&id=3a5fc1af&scoped=true"
import script from "./j-icon.vue?vue&type=script&lang=js"
export * from "./j-icon.vue?vue&type=script&lang=js"

import "./j-icon.vue?vue&type=style&index=0&id=3a5fc1af&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5fc1af"]])

export default __exports__